<template>
  <BModal id="modal-tall" :model-value="modal" scrollable centered title="Checkin" @update:modelValue="updateModal"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Checkin</h5>
        <!-- <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div class="bg-success rounded-circle" style="width: 10px; height: 10px;"></div>
          <span>online: Ruth</span>
        </div> -->
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Extracharge">
        <BForm>
          <BRow v-for="ext,index in extracharges" :key="index">
            <BCol md="5">
                <div class="form-group">  
                  <BFormSelect v-model="extracharge.selectedCategory" :options="ext.categories">
                    <template #first>
                      <BFormSelectOption :value="null" disabled>Select type room</BFormSelectOption>
                    </template>
                  </BFormSelect>
                  <!-- <select v-model="extracharge.selectedCategory" name="" id="" class="form-select">
                    <option value="" disabled>Select Category</option>
                    <option v-for="category,index in ext.categories" :value="category.value" :key="index">{{category.label}}</option>
                  </select> -->
                </div>

            </BCol>
            <BCol md="3">
                <div class="form-group">  
                  <BFormSelect v-model="extracharge.selectedItem" :options="filteredItems">
                    <template #first>
                      <BFormSelectOption :value="null" disabled>Select type room</BFormSelectOption>
                    </template>
                  </BFormSelect>
                  <!-- <select v-model="extracharge.selectedItem" name="" id="" class="form-select" >
                    <option value="" disabled>Select Item</option>
                    <option v-for="item,index in filteredItems" :key="index" :value="item.value">{{ item.label }}</option>
                  </select> -->
                </div>
            </BCol>
            <BCol md="4">
              <div class="form-group">
                <BInputGroup>
                  <BButton variant="light" class="border"><i class="fas fa-minus" @click="decreaseQuantity(index)"></i></BButton>
                  <BFormInput type="number" v-model="ext.quantity" min="0" class="text-center"></BFormInput>
                  <BButton variant="light" class="border"><i class="fas fa-plus" @click="increaseQuantity(index)"></i></BButton>
                </BInputGroup>
                <!-- <BFormInput type="number" placeholder="0"></BFormInput> -->
              </div>
            </BCol>
          </BRow>
          <div class="cta mb-3">
            <BButton variant="danger" @click="deleteItemExtracharge" class="mr-2"><i class="fas fa-minus"></i></BButton>
            <BButton variant="success" @click="addItemExtracharge"><i class="fas fa-plus"></i></BButton>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0 ">Total Harga : <b class="font-weight-bold">{{  totalPrice }}</b></p>
          </div>
        </BForm>
      </BTab>
      <BTab title="Payment">
          <div class="form-group">
            <BFormSelect v-model="selectedPaymentMethod" :options="payment_methods">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select payment method</BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div class="form-group">
            <BFormInput type="number" placeholder="Deposit">
            </BFormInput>
          </div>
          <BRow>
            <BCol>
              <div class="form-group">
                <BFormInput type="text" placeholder="Discount">
                </BFormInput>
              </div>
            </BCol>
            <BCol>
              <div class="form-group">
                <BFormInput type="text" placeholder="Grand Total" disabled>
                </BFormInput>
              </div>
            </BCol>
          </BRow>
          <div class="form-group">
            <BFormInput type="number" placeholder="Sisa Tagihan">
            </BFormInput>
          </div>
          <div class="form-group">
            <label for="">Payment Date</label>
            <BFormInput type="date">
            </BFormInput>
          </div>
          
          <div class="form-group">
            <BFormTextarea v-model="textEx" placeholder="Remarks" rows="3" />
          </div>
      </BTab>
    </BTabs>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton>
            <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { ref, computed } from "vue";

import { 
  BRow, 
  BCol, 
  BForm, 
  BModal, 
  BTabs,
  BTab,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BInputGroup, 
  BButton,
  // BListGroup,
  // BListGroupItem,
  // BFormTextarea, 
  // BFormRadioGroup
 } from "bootstrap-vue-next";
export default {
    props: {
        modal: Boolean,
    },
    name: 'CheckInForm',
    components: {
        BRow, 
        BCol,
        BForm,
        BTabs,
        BTab,
        BModal,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BInputGroup,
        BButton,
        // BListGroup,
        // BListGroupItem,
        // BFormTextarea,
        // BFormRadioGroup
    },
    
    emits: ["update:modal"],
    
    setup(props, {emit}){
        const options = ref([
            {
                text: 'Ya',
            },
            {
                text: 'Tidak',
            },
        ])
        const searchQuery = ref("")
        const selectedPaymentMethod = ref(null)
        const payment_methods = ref([
          {text:'Credit Card'}, 
          {text:'Cash'}, 
          {text:'Transfer Bank'}, 
          {text:'E-Wallet'}
        ])
        const guests = ref([
          'Mr Bones', 'Ms Catherine', 'Mr Brandon', 'Mr Robert', 'Ms Emma'
        ])
        const extracharge = ref(
          {
            selectedCategory: null,
            categories: [
              {
                text: 'Resto',
                value: 'resto'
              },
              {
                text: 'Hotel',
                value: 'hotel'
              },
              {
                text: 'Travel',
                value: 'travel'
              },
            ],
            selectedItem: null,
            items: [
              {
                text: "Lunch Buffet 30 Pax", value: "", category: 'resto', price: 50000
              },
              {
                text: "Ayam Rujak", value: "", category: 'resto', price: 50000
              },
              {
                text: "Ayam Soto", value: "", category: 'resto', price: 50000
              },
              {
                text: "Airport Shuttle 9 Person", value: "", category: 'travel', price: 70000
              },
              {
                text: "City Tour in Medan", value: "", category: 'travel', price: 70000
              },
              {
                text: "Day Trip Brastagi", value: "", category: 'travel', price: 70000
              },
              {
                text: "Extra Bed", value: "", category: 'hotel', price: 70000
              },
              {
                text: "Phone Charge", value: "", category: 'hotel', price: 70000
              },
            ],
            quantity: 0,
          }
        )
        const extracharges = ref([
          {
            ...extracharge.value
          }
        ])
        const addItemExtracharge = () => {
          extracharges.value.push({...extracharge.value})
        }
        const deleteItemExtracharge = () => {
          if(extracharges.value.length > 1){
            extracharges.value.pop()
          }
        }
        const increaseQuantity = (index) => {
          extracharges.value[index].quantity++;
        }
        const decreaseQuantity = (index) => {
          if (extracharges.value[index].quantity > 0) {
            extracharges.value[index].quantity--;
          }
        }
        console.log(props)
        const updateModal = (value) => {
                emit("update:modal", value); // Sync modal state with parent
            };

        const totalPrice = computed(() => {
          return extracharges.value.reduce((sum, ext) => {
            const selectedItem = ext.items.find(item => item.value === ext.selectedItem);
            return sum + (selectedItem ? selectedItem.price * ext.quantity : 0);
          }, 0);
        });

        const filteredItems = computed(() => {
          return extracharge.value.items.filter(item => item.category === extracharge.value.selectedCategory)
        })
        const filteredGuestItems = computed(() => {
          if (!searchQuery.value) return [];
          return guests.value.filter(item =>
            item.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
        });

        return{
            updateModal,
            addItemExtracharge,
            deleteItemExtracharge,
            increaseQuantity,
            decreaseQuantity,
            filteredGuestItems,
            filteredItems,
            totalPrice,
            guests,
            extracharges,
            searchQuery,
            extracharge,
            payment_methods,
            selectedPaymentMethod,
            options
        }
    }

}
</script>

<style>

</style>